import { Box, SxProps, Theme, useTheme } from "@mui/material";
const getStyle = (theme: Theme) => {
  const boxHover: SxProps<Theme> = {
    width: 6,
    height: 6,
    left: -10,
    opacity: 0,
    scale: 0,
    transition:
      "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), scale 200ms cubic-bezier(0.4, 0, 0.2, 1)",
    backgroundColor: theme.palette.primary[200],
    borderRadius: "50%",
    position: "absolute",
  };
  return { boxHover };
};
export const CircleHover = () => {
  const theme = useTheme();
  const styles = getStyle(theme);
  return <Box className="circle-hover" sx={styles.boxHover} />;
};
